import { useQuery } from '@apollo/client';
import { GET_CALLS_GROUPED_BY_STAGE } from '../graphql/queries';

export interface CallsGroupedByStage {
  executionDate: string;
  stage: string;
  count: number;
}

interface UseCallsGroupedByStageProps {
  startDate: Date;
  endDate: Date;
  agentId?: string;
  minDurationSecs?: number;
  maxDurationSecs?: number;
  callDirection?: 'incoming' | 'outgoing';
}

export const useCallsGroupedByStage = ({
  startDate,
  endDate,
  agentId,
  minDurationSecs,
  maxDurationSecs,
  callDirection,
}: UseCallsGroupedByStageProps) => {
  const { loading, error, data } = useQuery(GET_CALLS_GROUPED_BY_STAGE, {
    variables: {
      startDate: startDate.toISOString(),
      endDate: endDate.toISOString(),
      ...(agentId && { agentId }),
      minDurationSecs,
      maxDurationSecs,
      callDirection,
    },
  });

  return {
    loading,
    error,
    data: data?.getCallsGroupedByStage as CallsGroupedByStage[] | undefined,
  };
};
